import { render, staticRenderFns } from "./CheckBoxFilter.vue?vue&type=template&id=b055c6e6"
import script from "./CheckBoxFilter.vue?vue&type=script&lang=js"
export * from "./CheckBoxFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports